import { useLocation } from 'react-router';
import ClaimListing, { CLAIM_STATUS_DONE_BG_COLOR, ClaimColumns, ClaimFilters } from '../shared/ClaimListing/ClaimListing';

export const getRowColorByStatus = (row: Record<string, any>) => {
  const { status } = row;
  if (status === 'Done') return { backgroundColor: CLAIM_STATUS_DONE_BG_COLOR };
  return {};
};

export default function SearchTab() {
  const { search } = useLocation();
  const queryParms = new URLSearchParams(search);

  const filters = Object.values(ClaimFilters).map((filter) => {
    if (queryParms.has(filter.name)) {
      let value: any = queryParms.get(filter.name);

      // normalize boolean-like params
      if (value === 'true') value = true;
      if (value === 'false') value = false;
      
      return {
        ...filter,
        initialValue: value,
      };
    }
    return filter;
  });

  return (
    <ClaimListing
      autoCheckout={false}
      defaultRowsPerPage={100}
      defaultOrder="desc"
      rowSx={getRowColorByStatus}
      columns={Object.values(ClaimColumns)}
      filters={filters}
    />
  );
}
